import { type FullNavData } from "~/features/navigation/redux/loadNavigationEpic";

export const BEGIN_LOADING_NAVIGATION = "Navigation: load from api";
export const LOADING_SUCCESS = "Navigation: load to storage";

export function beginLoadingAction() {
  return {
    type: BEGIN_LOADING_NAVIGATION,
  } as const;
}

export function loadingSuccessAction(data: FullNavData) {
  return {
    type: LOADING_SUCCESS,
    payload: data,
  } as const;
}

export type NavigationActions = ReturnType<typeof beginLoadingAction> | ReturnType<typeof loadingSuccessAction>;
